
import { Component, Vue } from "vue-property-decorator";
import request from "@/lib/request/request";

@Component({
  components: {}
})
export default class App extends Vue {
  isShowPage = false; //是否展示页面
  videoPlay = require("@/assets/videoPlay.png");
  wxBgBorder =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  connectCode = "";
  mainColor = "";
  examName = "";
  textOpacity = 1.0;
  examExpireTextMessage = "";
  examExpireTitle = "面试已过期";
  publicityPageVideoCoverUrl = "";
  publicityPageVideoUrl = "";
  videoPlaying = false;
  video: any = null;

  contentOverflow = "hidden";
  scroolHeight = 0;
  touchHeight = 0;
  footerHeight = 0;

  isInvalidNetwork = false;

  created() {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    const params = {};
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      params[pair[0]] = pair[1];
    }
    if (params["c"]) {
      this.connectCode = decodeURIComponent(params["c"]);
      // 如果短信链接带上后面的文字了，只提取数字
      const regex = /[\d_]+/g;
      const codes = this.connectCode.match(regex);
      if (codes && codes.length > 0) this.connectCode = codes[0];
      this.judgmentExamEnd();
    }
  }

  // 刷新当前页
  refresh() {
    location.reload();
  }

  onChange() {
    if (this.video) {
      this.video[["play", "pause"][Number(this.videoPlaying)]]();
      this.videoPlaying = !this.videoPlaying;
    }
  }

  // 查看更多
  get checkMoreText(): boolean {
    return this.textOpacity > 0 && this.touchHeight > 228;
  }

  jumpNext() {
    request
      .post(
        "/aiExam/common/url",
        {
          connectCode: this.connectCode
        },
        false
      )
      .then(resp => {
        if (resp.data.data.url) {
          window.location = resp.data.data.url;
        } else {
          //   this.$message.error("")
        }
      })
      .catch(err => {
        // this.$message.error("登录失败");
        this.isInvalidNetwork = err.data.code === -500;
        this.onInvalidExam();
      });
  }

  // 面试不存在
  onInvalidExam() {
    this.isShowPage = true;
    // this.examExpireTextMessage = "该面试不存在，请参与正确的面试场次";
    this.publicityPageVideoCoverUrl = this.wxBgBorder;
    this.examName = this.isInvalidNetwork
      ? "很抱歉，由于网络连接问题，我们无法加载您的面试信息。请检查您的网络连接并重试。"
      : "当前面试链接已失效，请您尽快与相关工作人员联系";
    this.examExpireTitle = this.isInvalidNetwork ? "刷新页面" : "面试已失效";
    this.setContentScroll();
  }

  // 判断面试是否结束
  async judgmentExamEnd() {
    try {
      const result = await request.post(
        "/aiExam/old/joinStatus",
        {
          connectCode: this.connectCode
        },
        false
      );
      if (result.data.code === 0) {
        //面试已结束 或 面试登记已截止  则展示页面
        this.isShowPage =
          result.data.data.joinStatus === 2 ||
          result.data.data.isExpireRegisterTimeLimit === 1;
        if (!this.isShowPage) {
          this.jumpNext();
        } else {
          this.examName = result.data.data.examName;
          this.publicityPageVideoUrl = result.data.data.publicityPageVideoUrl;
          this.publicityPageVideoCoverUrl =
            result.data.data.publicityPageVideoCoverUrl;
          this.examExpireTextMessage = result.data.data.examExpireTextMessage;
          this.mainColor = result.data.data.styleConfig.mainColor;
          this.setContentScroll();
          if (this.publicityPageVideoUrl) {
            this.$nextTick(() => {
              this.video = document.querySelector("#video") as HTMLVideoElement;
            });
          }
          if (
            result.data.data.isExpireRegisterTimeLimit === 1 &&
            result.data.data.joinStatus !== 2
          ) {
            this.examExpireTitle = "面试已截止登记";
          }
        }
      } else {
        this.onInvalidExam();
      }
    } catch (error) {
      this.isInvalidNetwork = error.data.code === -500;
      this.onInvalidExam();
    }
  }

  // 设置内容区滚动
  setContentScroll() {
    this.$nextTick(() => {
      this.scroolHeight = (document.querySelector(
        ".scrool"
      ) as HTMLElement).offsetHeight;
      this.contentOverflow = this.scroolHeight === 0 ? "auto" : "hidden";
      this.touchHeight = (document.querySelector(
        ".touch"
      ) as HTMLElement).offsetHeight;
      this.footerHeight = (document.querySelector(
        ".footer"
      ) as HTMLElement).offsetHeight;
    });
  }

  onScroll(e: any) {
    const heightPoor = this.scroolHeight + this.touchHeight - this.footerHeight;
    const scrollTop = heightPoor > 50 ? 50 : heightPoor;
    this.contentOverflow =
      e.target.scrollTop === this.scroolHeight ? "auto" : "hidden";
    if (scrollTop >= e.target.scrollTop && e.target.scrollTop >= 0) {
      this.textOpacity = (scrollTop - e.target.scrollTop) / scrollTop;
    } else if (scrollTop < e.target.scrollTop) {
      this.textOpacity = 0.0;
    }
  }
}
